import gql from 'graphql-tag';

const dealerInformationQuery = gql`
  query dealerInformationQuery($dealerNumber: String!) {
    dealerInformation(dealerNumber: $dealerNumber) {
      dealerNo
      dealerName
    }
  }
`;

export default dealerInformationQuery;
